import React from 'react';
import { Link } from 'react-scroll';
import { useLocation, useNavigate } from 'react-router-dom';

const Logo = (props) => {
  
  const location = useLocation();
  const navigate = useNavigate();

  const isIndexPage = location.pathname === "/";

  const handleClick = () => {
    if (isIndexPage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate("/");
    }
  };

  return (
    <div className="flex-column">
      
      {isIndexPage ? (
        <Link
          to="home"
          smooth={true}
          duration={500}
          className="logo-link"
        >
          <img className={props.footer ?("logo"):("logo-header")} src={props.img} alt={props.alt} />
        </Link>
      ) : (
        <img
          className="logo-header"
          src={props.img}
          alt={props.alt}
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        />
      )}
    </div>
  );
};

export default Logo;
